import React from "react";
import { Card, CardBody, Col, Label, Row } from "reactstrap";
import { FormLead } from "../../../../cores/facebookForm/interfaces/api/get-facebook-form";
import { useFacebookFormCore } from "../../../../cores/facebookForm";
import { View } from "../../../../cores/facebookForm/constants/view";
import cn from "classnames";

interface Props {
  facebookFormLead: FormLead;
  questions: string[];
  mode?: string;
  onOpenContact?: () => void;
}

export default function LeadCard(props: Props) {
  const { facebookFormLead, questions, mode, onOpenContact } = props;
  const { view } = useFacebookFormCore();
  const effectiveView = mode || view;

  return (
    <Card key={facebookFormLead.id} className="facebook-lead-card border-0">
      <CardBody className="facebook-lead-card__body">
        <Row>
          <Col
            md={effectiveView === View.GRID ? "12" : "8"}
            xs="12"
            className={cn("d-flex flex-column", {
              "text-center": effectiveView === View.GRID,
            })}
          >
            {facebookFormLead.data.map((data, index) => (
              <Label key={`${facebookFormLead.id}-${index}`} className="facebook-lead-card__field">
                {effectiveView === View.LIST && (
                  <span className="facebook-lead-card__question">{questions[index]}: </span>
                )}
                <span className="facebook-lead-card__value">{data}</span>
              </Label>
            ))}
          </Col>
          <Col
            md={effectiveView === View.GRID ? "12" : "4"}
            xs="12"
            className={cn({
              "text-center": effectiveView === View.GRID,
              "text-right": effectiveView === View.LIST,
            })}
          >
            <span className="facebook-lead-card__time">{facebookFormLead.createdTime}</span>
          </Col>
        </Row>
        {onOpenContact ? (
          <div className="mt-2 d-flex justify-content-end">
            <button type="button" className="facebook-lead-card__action" onClick={onOpenContact}>
              Abrir / crear contacto
            </button>
          </div>
        ) : null}
      </CardBody>
    </Card>
  );
}
